import React from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../../hooks/useLanguage';
import { HowItWorksContent } from './HowItWorksContent';

export const HowItWorksModal = ({ isOpen, onClose }) => {
  const [isSpanish] = useLanguage();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] animate-fadeIn">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4 animate-modalEnter max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-start mb-6">
          <h2 className="text-2xl font-bold">
            {isSpanish ? 'Cómo Funciona' : 'How It Works'}
          </h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-6 h-6 text-gray-600" />
          </button>
        </div>

        <HowItWorksContent />
      </div>
    </div>
  );
};

export default HowItWorksModal;

